"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkProcessWeaponCommand = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageWeaponCommand_1 = require("@voyage/multi/voyageMessageWeaponCommand");
var voyageMessageWeaponCommand_sidecar_1 = require("@voyage/multi/voyageMessageWeaponCommand-sidecar");
var voyageCamera_shaker_sidecar_1 = require("@voyage/camera/voyageCamera_shaker-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 3;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        // No power needed
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var sys = tHere.system;
            assert_sidecar_1.assert.notNil(sys);
            if (sys.ammo > 0) {
                if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                    voyageMessageWeaponCommand_sidecar_1.voyageMessageWeaponCommand.sendMessageAndImmediatelyExecute({
                        command: voyageMessageWeaponCommand_1.EWeaponCommand.Fire,
                        systemId: sys.id,
                        crewId: obj.id,
                    });
                    // sys.ammo--
                    // diveCrew.say(obj, 'Firing!')
                    // voyageSounds.playFireTorpedo()
                    // voyageCamera_shaker.shake()
                    // voyageGameStatus_enemyShips.hurt(25)
                    // let firePointSys = voyageTilemap.getSystemSafeByKey('fp-' + t.text3)
                    // let fp = t
                    // if (firePointSys) {
                    //   fp = firePointSys
                    // }
                    // voyageParticles.createMultiple(
                    //   'torpedo',
                    //   voyageTilemap.convertItoX(fp.i),
                    //   voyageTilemap.convertJtoY(fp.j),
                    //   1,
                    // )
                }
            }
            else {
                diveCrew_sidecar_1.diveCrew.say(obj, 'No torpedo loaded!');
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
function networkProcessWeaponCommand(msg, obj, t, sys) {
    if (msg.command === voyageMessageWeaponCommand_1.EWeaponCommand.Fire) {
        sys.ammo--;
        diveCrew_sidecar_1.diveCrew.say(obj, 'Firing!');
        voyageSounds_sidecar_1.voyageSounds.playFireTorpedo();
        voyageCamera_shaker_sidecar_1.voyageCamera_shaker.shake();
        voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hurt(50);
        var firePointSys = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe('fp-' + t.text3);
        var fp = t;
        if (firePointSys) {
            fp = firePointSys;
        }
        voyageParticles_sidecar_1.voyageParticles.createMultiple('torpedo', voyageTilemap_sidecar_1.voyageTilemap.convertItoX(fp.i), voyageTilemap_sidecar_1.voyageTilemap.convertJtoY(fp.j), 1);
    }
    if (msg.command === voyageMessageWeaponCommand_1.EWeaponCommand.Load) {
        sys.ammo = 1;
        diveCrew_sidecar_1.diveCrew.say(obj, 'Torpedo loaded');
        voyageSounds_sidecar_1.voyageSounds.playLoadTorpedo();
    }
}
exports.networkProcessWeaponCommand = networkProcessWeaponCommand;
